import { FC, PropsWithChildren, useMemo } from 'react';

import { PageViewContext } from './PageViewContext';
import { usePageViewTracking, UsePageViewTrackingProps } from './usePageViewTracking';

/**
 * Mounts page_view tracking and exposes `trackVirtualPageView` to the tree
 * below, so components can report pages that have no URL of their own (a
 * form-save confirmation, for example).
 *
 * It has to wrap children rather than sit beside them: the payload is assembled
 * here from the route and profile props, and the call sites are somewhere in the
 * app tree.
 */
export const PageViewTracker: FC<PropsWithChildren<UsePageViewTrackingProps>> = ({ children, ...props }) => {
  const { trackVirtualPageView, trackPageView } = usePageViewTracking(props);
  const value = useMemo(() => ({ trackVirtualPageView, trackPageView }), [trackVirtualPageView, trackPageView]);

  return <PageViewContext.Provider value={value}>{children}</PageViewContext.Provider>;
};
